// extracted by mini-css-extract-plugin
module.exports = {"label":"CreateTransitionModal-module__label--3lsYx","header":"CreateTransitionModal-module__header--1vsHT"};